import {
  CommonTrackingConfig,
  getCustomClickTrackValues,
  mapTrackingProperties,
} from '../../../modules/utils/trackingHelper';

const resolveLinkType = (tracking?: CommonTrackingConfig): 'internal' | 'external' => {
  if (tracking?.linkType === 'external' || tracking?.linkType === 'internal') {
    return tracking.linkType;
  }

  return 'internal';
};

export const resolveWalletEmbeddedTracking = (tracking?: CommonTrackingConfig) => {
  const trackingProperties = mapTrackingProperties(tracking);
  const linkType = resolveLinkType(tracking);

  return {
    trackingProperties,
    customClickTrackValue: getCustomClickTrackValues(trackingProperties, linkType),
  };
};

/** Empty-state How to Earn: prefer AEM empty-state keys, then fall back to section tracking. */
export const resolveWalletEmptyHowToEarnTracking = (
  typeSpecificEmptyTracking?: CommonTrackingConfig,
  sharedEmptyTracking?: CommonTrackingConfig,
  sectionTracking?: CommonTrackingConfig
) => resolveWalletEmbeddedTracking(typeSpecificEmptyTracking ?? sharedEmptyTracking ?? sectionTracking);
